import { Subject } from 'rxjs'

export type FeedbackFeatureImperativeEvent = {
  type?: 'passive' | 'active'
  isAppInFullscreen?: boolean
}

const subject = new Subject<FeedbackFeatureImperativeEvent>()

export const FeedbackFeatureImperativeInterface = {
  showPassiveFeedback: () => subject.next({ type: 'passive' }),
  setAppInFullscreen: (isAppInFullscreen: boolean) => {
    subject.next({ isAppInFullscreen })
  },
  subscribe: (callback: (event: FeedbackFeatureImperativeEvent) => void) => {
    const subscription = subject.subscribe(callback)
    return () => subscription.unsubscribe()
  }
}
